import { packLargeImageUrl } from './packGalleryImageUrl';
export var SEASON_PREVIEW_MAX_SLIDES = 80;
export var SEASON_PREVIEW_LOGIN_MAX_SLIDES = 24;
export var SEASON_PREVIEW_LOGIN_POOL_MAX = 200;
export var SEASON_PREVIEW_LOAD_BATCH = 6;
/** Style code from pack URL path, e.g. …/packs/S24/1S24A104/8915/… → 1S24A104 */
export function extractStyleCodeFromPackUrl(url) {
    var match = String(url).match(/\/packs\/[^/]+\/([^/]+)\//i);
    return match ? match[1].toUpperCase() : String(url);
}
function isPrimaryPackImageUrl(url) {
    var _a;
    var filename = ((_a = String(url).split('/').pop()) === null || _a === void 0 ? void 0 : _a.split('?')[0]) || '';
    return !/_[A-Z]\d?\.(jpe?g|webp|png)$/i.test(filename);
}
function pickBestUrlForStyle(candidates) {
    var primary = candidates.find(isPrimaryPackImageUrl);
    return primary || candidates[0];
}
/** One image per style — avoids marquee filled with angles/colors of the same product. */
export function uniqueUrlsByStyle(urls) {
    var byStyle = new Map();
    urls.forEach(function (url) {
        if (!url) {
            return;
        }
        var style = extractStyleCodeFromPackUrl(url);
        var list = byStyle.get(style) || [];
        list.push(url);
        byStyle.set(style, list);
    });
    return Array.from(byStyle.values()).map(pickBestUrlForStyle);
}
export function collectSeasonPreviewUrls(imageMap) {
    if (!imageMap) {
        return [];
    }
    var seen = new Set();
    var urls = [];
    Object.keys(imageMap).forEach(function (variantKey) {
        var entries = imageMap[variantKey];
        if (!Array.isArray(entries)) {
            return;
        }
        entries.forEach(function (entry) {
            var large = packLargeImageUrl(entry.imageurl);
            if (large && !seen.has(large)) {
                seen.add(large);
                urls.push(large);
            }
        });
    });
    return uniqueUrlsByStyle(urls);
}
export function sampleSeasonPreviewUrls(urls, maxSlides) {
    if (maxSlides === void 0) { maxSlides = SEASON_PREVIEW_MAX_SLIDES; }
    var totalCount = urls.length;
    if (totalCount <= maxSlides) {
        return { stripUrls: urls, totalCount: totalCount };
    }
    return { stripUrls: urls.slice(0, maxSlides), totalCount: totalCount };
}
//# sourceMappingURL=seasonPreviewCollectUrls.js.map